import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  DollarOutlined,
} from '@ant-design/icons';

interface WithdrawalTransaction {
  id: number;
  amount: number;
  status: string;
}

interface WithdrawalServiceStatisticsProps {
  transactions: WithdrawalTransaction[];
  totalCount: number;
}

const WithdrawalServiceStatistics: React.FC<
  WithdrawalServiceStatisticsProps
> = ({ transactions, totalCount }) => {
  const completedTransactions = transactions.filter(
    (t) => t.status === 'COMPLETED'
  );
  const pendingTransactions = transactions.filter(
    (t) => t.status === 'PENDING'
  );

  return (
    <Row gutter={16} className="mb-6">
      <Col span={6}>
        <Card>
          <Statistic
            title="Tổng giao dịch"
            value={totalCount}
            valueStyle={{ color: '#1890ff' }}
            prefix={<DollarOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Đã hoàn thành"
            value={completedTransactions.length}
            valueStyle={{ color: '#52c41a' }}
            prefix={<CheckCircleOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Đang chờ"
            value={pendingTransactions.length}
            valueStyle={{ color: '#faad14' }}
            prefix={<ClockCircleOutlined />}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default WithdrawalServiceStatistics;
